import {Component, OnInit} from '@angular/core';
import {ThemePalette} from '@angular/material/core';
import {ProgressSpinnerMode} from '@angular/material/progress-spinner';
import {SwitchpayService} from '../../services/switchpay/switchpay.service';
import {InitializeSwitchpayResponse} from '../../interfaces/switchpay/InitializeSwitchpayResponse';
import {environment} from '../../../environments/environment';
import {Session} from '../../interfaces/session-data';


@Component({
  selector: 'app-switchpay',
  templateUrl: './switchpay.component.html',
  styleUrls: ['./switchpay.component.scss']
})
export class SwitchpayComponent implements OnInit {

  paymentMethod: string;
  paymentMethodImg = '';
  redirectUrl;
  controllerUrl;
  loading = true;

  // Loader
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'determinate';
  value = 50;
  diameter = 75;

  // Countdown
  config = {leftTime: 5, format: 's'};
  hidePgLogo = false;
  sessionData: Session;
  private callBackBaseUrl: string = environment.baseUrlCallback + '/callback/switchpay';

  constructor(
    private switchpayService: SwitchpayService
  ) {
    sessionStorage.setItem('selected-payment', 'switchpay');
    this.paymentMethod = 'switchpay';
    this.paymentMethodImg = `../../assets/icons/Payment_Cards/svg/image_${this.paymentMethod}.png`;

  }

  ngOnInit(): void {
    this.sessionData = JSON.parse(sessionStorage.getItem('sessionData'));
    this.hidePgLogo = this.sessionData?.sessionDisplayInformation?.hidePgLogo === 'true';
    this.controllerUrl = this.callBackBaseUrl + `/redirect/${sessionStorage.getItem('sessionToken')}`;

    this.switchpayService.initializeSwitchpay(sessionStorage.getItem('sessionToken')).subscribe((data: InitializeSwitchpayResponse) => {
      this.redirectUrl = data.redirectUrl;
      const timeout = 5;
      setTimeout(() => {
        (document.getElementById('switchpay-form') as HTMLFormElement).submit();
      }, timeout * 1000);
    });

  }

}
